import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import { TSetUserJobValues } from 'core/models/Job/job.model';

interface IUserJobState {
  initialEditValues: TSetUserJobValues | null;
  isModalOpen: boolean;
}

const initialState: IUserJobState = {
  initialEditValues: null,
  isModalOpen: false,
};

const userJobSlice = createSlice({
  name: 'userJob',
  initialState,
  reducers: {
    setInitialEditValues: (state, action: PayloadAction<TSetUserJobValues>) => {
      state.initialEditValues = action.payload;
    },
    resetInitialEditValues: (state) => {
      state.initialEditValues = null;
    },
    setIsModalOpen: (state, action: PayloadAction<boolean>) => {
      state.isModalOpen = action.payload;
    },
  },
});

export const { setInitialEditValues, resetInitialEditValues, setIsModalOpen } =
  userJobSlice.actions;

export default userJobSlice.reducer;
